import { Button, Typography } from '@mui/material'
import TimelineV2 from 'components/PatientTimelineDialog/TimelineV2'
import { RoutePaths } from 'containers/Core/Routes'
import { memo } from 'react'
import { useHistory } from 'react-router'
import { Patient } from '../types'

import './styles.scss'

interface PatientTimelineProps {
  patient: Patient
}

const PatientTimeline: React.FC<PatientTimelineProps> = ({ patient }) => {
  const history = useHistory()
  const openPatientView = () =>
    history.push(`${RoutePaths.DASHBOARD_PATIENTS}/${patient.id}`)
  const closePatientView = () => history.push(RoutePaths.DASHBOARD_PATIENTS)

  return (
    <div className="patient-view-container pt-4 pb-6">
      <div className="d-flex align-items-center justify-content-between mx-4">
        <Typography variant="h4" className="patient-name">
          {patient?.firstName}{' '}
          {patient?.preferredName ? `(${patient.preferredName})` : ''}{' '}
          {patient?.lastName}
        </Typography>
        <div className="d-flex">
          <Button variant="contained" onClick={openPatientView}>
            Open Patient View
          </Button>
          <Button
            variant="contained"
            className="cancel-button button-margin"
            onClick={closePatientView}
          >
            Close
          </Button>
        </div>
      </div>

      <div className="mx-4">
        <TimelineV2 patientId={patient.id} />
      </div>
    </div>
  )
}

export default memo(PatientTimeline)
